import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { Store } from "bernie-core";

export interface ThumborStore extends Store {
  safelyGenerateThumborizedImageUrl: (
    imageUrl: string,
    width: number,
    height: number,
    context?: ExtendedContextStore,
    ratio?: AspectRatioEnum,
    smartCropEnabled?: boolean,
    quality?: number
  ) => string;
}

export enum AspectRatioEnum {
  DEFAULT = "16-9",
  R_2_1 = "2-1",
  R_21_9 = "21-9",
  R_1_1 = "1-1",
  R_3_2 = "3-2",
  R_4_3 = "4-3",
}
